export default __webpack_public_path__ + "static/media/option-item.5d01b0d3.png";